import HARDCODE from '../../../business-const/HardCode/HardCode'



export const processaRegistrosDefaultIniciaisSimulacaoFinanceiraAporteRetiradaMensal = ( values ) => {

    if (!values.aporteRetiradaMensal) {

        values.aporteRetiradaMensal = JSON.parse(JSON.stringify(HARDCODE.aporteRetiradaMensalInit))
    }
}